import React, { useLayoutEffect, useRef } from 'react'
import { RiReactjsFill } from 'react-icons/ri';
import homeLogo from '../../Assets/homeLogo.png';
import ShootingStar from '../../Components/Shooting star/Shootingstar';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';
import "./header.css"
import HeaderContent from '../headercontent/HeaderContent';


gsap.registerPlugin(ScrollTrigger);
const CircularText = ({ className, text, radius, range, startPos, css, bottomCss }) => {
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        const textArr = text.split('');
        const container = containerRef.current;
        if (!container) return;

        const containerHeight = container.clientHeight;
        const newElement = document.createElement('div');
        newElement.setAttribute('class', className);

        let currentPos = startPos;
        const deg = range / textArr.length;

        textArr.forEach((ch) => {
            const p = document.createElement('p');
            p.style.height = `${radius}px`;
            p.style.cssText += css;
            p.style.transform = `rotate(${currentPos}deg)`;
            p.style.left = '50%';
            p.style.top = `${containerHeight / 2 - radius}px`;
            p.style.position = 'absolute';
            p.style.transformOrigin = '0 100%';

            const span = document.createElement('span');
            span.style.cssText = bottomCss;
            span.innerHTML = ch;

            p.appendChild(span);
            newElement.appendChild(p);

            currentPos += deg;
        });

        container.appendChild(newElement);

        // Cleanup function to remove the added element when the component unmounts
        return () => {
            if (container.contains(newElement)) {
                container.removeChild(newElement);
            }
        };
    }, [className, text, radius, range, startPos, css, bottomCss]);

    return <div ref={containerRef} className="containerr-" />;
};

const Header = () => {




    const headerRef = useRef(null);
    const scaleRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            const header = headerRef.current;
            const scale = scaleRef.current;

            // GSAP timeline setup
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: header,
                    start: 'top top',
                    end: '+=2500', // Adjust as needed
                    pin: true,
                    scrub: 1,
                },
            });

            tl.to(scale, {
                duration: 1,
                translateX: -1000,
                ease: 'power1.out',
            })


            // You can add more animations here

        }, headerRef);

        return () => ctx.revert();
    }, []);

    return (
        <div className="Home-Container1" id='Header'>
            <section className="headerhome" ref={headerRef}>
                <div className="playground">
                    <div className="logo top"> <RiReactjsFill /> </div>
                    {/* <div className="logo bot"> <RiReactjsFill /> </div> */}

                    <div className="scale" ref={scaleRef}>
                        <CircularText
                            className="text circTxt1"
                            text="FRONT~END Web Developer"
                            radius={260}
                            range={-170}
                            startPos={-100}
                            css="font-size: 34px;"
                            bottomCss="transform: scaleY(-1) scaleX(-1); position:absolute"
                        />
                        <CircularText
                            className="text circTxt2"
                            text="Mohamed~Metwally"
                            radius={260}
                            range={170}
                            startPos={-80}
                            css="font-size: 34px;"
                            bottomCss=""
                        />
                        <div className="playLogo"> <img src={homeLogo} alt="" /> </div>
                        <CircularText
                            className="text circTxt1"
                            text="Front~End Web Developer"
                            radius={200}
                            range={180}
                            startPos={-85}
                            css="font-size: 16px; color:#aaa;"
                            bottomCss=""
                        />
                        <CircularText
                            className="text circTxt2"
                            text="WEB DESINER"
                            radius={200}
                            range={-95}
                            startPos={-135}
                            css="font-size: 16px; color:#999;"
                            bottomCss="transform: scaleY(-1) scaleX(-1); position:absolute"
                        />
                    </div>

                </div>
                <ShootingStar />
            </section>
            <HeaderContent />
        </div>
    )
}

export default Header